import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import { useState } from "react";
import { Card, Grid, TextField } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useCustomerValue } from "providers/CustomerContext";
import { getDONumberOption,getDeliveryOrderReport } from "services/data.report.service";
import { InboundLayout } from "ui-components/Layout";
import { LoadingDialog } from "ui-components/Alert";
import { SelectFields } from "ui-components/Form";
import { downloadPDF2, downloadFile } from "layouts/views/common/file";
import { Error_ } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";

// 支持一次贴多个 DONumber / CustOrdNbr，用逗号或换行分隔
const parseDONumbers = (raw) =>
  (raw ?? "")
    .split(/[\n,]/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);

function DeliveryOrderReport() {
  const {permissions, allowAll} = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ content="Invalid Request" onChange={setAlert} />);
  const exportPermission = allowAll || (Boolean(permissions["Delivery Order Report_Report"]) && permissions["Delivery Order Report_Report"].findIndex(b => b==="export") !== -1);

  const downloadReportMutation = useMutation(getDeliveryOrderReport, {
    onSuccess: (response) => {
      const fileLabel = DONumberList.length === 1 ? DONumberList[0] : `DeliveryOrder_${DONumberList.length}`;
      if (reportType === "PDF") {
        downloadPDF2(response.data,`${fileLabel}.pdf`);
      } else {
        downloadFile(response.data, `${fileLabel}.csv`);
      }
    },
    onError,
  });

  const [DONumberOptions, setDONumberOptions] = useState([]);
  const [DONumber, setDONumber] = useState("");
  const [reportType, setReportType] = useState("PDF");

  const DONumberList = parseDONumbers(DONumber);

  const handleSubmit = (printPL=null) => {
    setAlert(null);
    downloadReportMutation.mutate({
      customerCode,
      DONumber: DONumberList,
      reportType,
      reportName: "DeliveryOrder",
      printPL
    });
  };

  useQuery({
    queryKey: ["report-delivery-order", { customerCode }],
    queryFn: () => getDONumberOption({ customerCode }),
    enabled:Boolean(customerCode),
    onSuccess: (data) => {
      setDONumber("");
      setDONumberOptions(data.data.data);
    },
  });

  const downloadStatus = downloadReportMutation.status === "loading";

  return (
    <InboundLayout>
      {downloadStatus && <LoadingDialog />}

      <Card sx={{ height: "100%" }}>
        <MDBox p={3}>
          {alert}
          <MDBox pb={3}>
            <MDTypography color="info" variant="h3">
              Export Delivery Order Report
            </MDTypography>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              {/* <SelectFields
                field={{
                  name: "DONumber",
                  label: "Delivery Order Number",
                  value: DONumber,
                  errors: {},
                  required: true,
                }}
                options={DONumberOptions}
                onChange={(e, v) => setDONumber(v)}
              /> */}
              <TextField
                name="doNumber"
                label="Delivery Order Number / Cust Order Number"
                helperText="Paste multiple numbers separated by comma or new line to print in batch"
                value={DONumber}
                onChange={({ target }) => setDONumber(target.value)}
                multiline
                minRows={3}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "reportType",
                  label: "Export to File Type *",
                  value: reportType,
                  errors: {},
                  required: true,
                }}
                options={["PDF", "CSV"]}
                onChange={(e, v) => setReportType(v)}
              />
            </Grid>
          </Grid>

          <MDBox mt={2} display="flex" justifyContent="center">
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              disabled={DONumberList.length === 0 || !exportPermission}
              onClick={()=>{handleSubmit(true)}}
            >
              Download
            </MDButton>
            <MDButton
              sx={{ml:1}}
              type="submit"
              variant="gradient"
              color="info"
              disabled={DONumberList.length === 0 || !exportPermission}
              onClick={()=>{handleSubmit(null)}}
            >
              Download DO only
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </InboundLayout>
  );
}

export default DeliveryOrderReport;
